import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-update-address-success',
  templateUrl: './update-address-success.component.html',
  styleUrls: ['./update-address-success.component.scss']
})
export class UpdateAddressSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
